export class UserTermsDataModel {

	TermsSigned: boolean;
	TermsDocumentLegal: string;

	constructor(termsSigned: boolean, termsDocumentLegal: string) {
		this.TermsSigned = termsSigned;
		this.TermsDocumentLegal = termsDocumentLegal;
	}

}
